module.exports = __webpack_public_path__ + "Flag-858.e38294b6c0c0fc3689667f1d6678bde3.svg";